export default __webpack_public_path__ + "static/media/wave-blue.da82f34d.png";